"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_TASK = exports.DELETE_TASK = exports.GET_TASKS = exports.UPDATE_TASK = exports.CREATE_TASK = exports.TASKS_FIELDS_FRAGMENT = void 0;
const client_1 = require("@apollo/client");
exports.TASKS_FIELDS_FRAGMENT = (0, client_1.gql) `
  fragment TasksFieldsFragment on Task {
    id
    name
    description
    status
    assignees {
      id
      email
    }
    createdAt
    updatedAt
    dueDate
    targetSubmissionType {
      id
      name
      currentUserCanCreate
    }
    relatedSubmission {
      id
    }
    targetObject {
      ... on Property {
        id
        streetAddress
        fullAddress
        latitude
        longitude
      }
      ... on CustomMapGeometry {
        id
        label
        customMapId
      }
    }
  }
`;
exports.CREATE_TASK = (0, client_1.gql) `
  mutation CreateTask($data: CreateTaskInput!) {
    createTask(data: $data) {
      ...TasksFieldsFragment
    }
  }

  ${exports.TASKS_FIELDS_FRAGMENT}
`;
exports.UPDATE_TASK = (0, client_1.gql) `
  mutation UpdateTask($data: UpdateTaskInput!) {
    updateTask(data: $data) {
      ...TasksFieldsFragment
    }
  }

  ${exports.TASKS_FIELDS_FRAGMENT}
`;
exports.GET_TASKS = (0, client_1.gql) `
  query GetTasks($objectId: ID!, $objectType: ObjectType!) {
    tasks(objectId: $objectId, objectType: $objectType) {
      ...TasksFieldsFragment
    }
  }

  ${exports.TASKS_FIELDS_FRAGMENT}
`;
exports.DELETE_TASK = (0, client_1.gql) `
  mutation DeleteTask($id: ID!) {
    deleteTask(id: $id)
  }
`;
exports.GET_TASK = (0, client_1.gql) `
  query GetTask($id: ID!) {
    task(id: $id) {
      ...TasksFieldsFragment
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,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